export default [
  {path: 'sites', component: () => import('./components/ListaSites.vue'), name: 'sites.lista'},
  {path: 'sites/:id', component: () => import('./components/Site.vue'), name: 'sites.show'},
]
